/**
 * DateTime
 * @namespace gplans.dashboard.services
 */
(function () {
  'use strict';

  angular.
  module('gplans.dashboard.services').
  factory('TempCheckin', TempCheckin);

  TempCheckin.$inject = ['$rootScope', '$q', 'Profile', 'Mealplan', 'DateTime', 'UserService'];TempCheckin.$inject = ["$rootScope", "$q", "Profile", "Mealplan", "DateTime", "UserService"];

  function TempCheckin($rootScope, $q, Profile, Mealplan, DateTime, UserService) {

    var TempCheckin = {
      createCheckin: createCheckin,
      setDay: setDay };


    return TempCheckin;

    // TODO: refactor
    // a) either we encapsulate checkin into separate service (Checkin) and remove from user object
    // b) or we hide it's functions inside User service when we do it
    function createCheckin(checkinData) {
      return Profile.createCheckin(checkinData).then(function (res) {
        UserService.data.last_checkin = res.data;
        setDay();
        return Mealplan.updatePlans();
      });
    }
    function setDay() {
      var d = DateTime.now();
      var checkinDate = DateTime.parseDate(UserService.data.last_checkin.created_at);
      UserService.data.last_checkin.day = DateTime.dayDiff(checkinDate, DateTime.parseDate(d.toISOString())) + 1;
    }
  }

})();